window.onload = function () {
  const popup = document.querySelector(".redirect-popup");
  const cancelButtons = document.querySelectorAll(".redirect-cancel");
  const popupCookieName = "redirect_popup_dismissed_uk";

  function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value}; path=/; expires=${date.toUTCString()}`;
  }

  function getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
          const [cookieName, cookieValue] = cookies[i].split("=");
          if (cookieName === name) {
              return cookieValue;
          }
      }
      return null;
  }

  function showPopup() {
      popup.style.display = "flex";
      setTimeout(() => {
          popup.style.opacity = "1";
      }, 10);
  }

  function hidePopup() {
      popup.style.display = "none";
      setCookie(popupCookieName, "true", 30);
  }

  if (getCookie(popupCookieName)) {
      popup.style.display = "none";
  } else {
      showPopup();
  }

  cancelButtons.forEach(button => {
      button.addEventListener("click", function (event) {
          event.preventDefault();
          hidePopup();
      });
  });

};
